var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"library-logo",on:{"click":function($event){return _vm.returnToBaseLibrary()}}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logoURL,"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }